import { render } from "./FloppyDiskIcon.vue?vue&type=template&id=2fa9be3a&scoped=true"
const script = {}

import "./FloppyDiskIcon.vue?vue&type=style&index=0&id=2fa9be3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fa9be3a"]])

export default __exports__